module.exports = __webpack_public_path__ + "img/sanfung_company_logo_footer.e1902e0c.png";